export var DEFAULT_AUTO_SCROLL_INTERVAL = 8000;
export var SHOW_INDICATORS_THRESHOLD = 14;
export var ARROW_POSITION = {
  center: 'center',
  top: 'top',
  bottom: 'bottom'
};
export var INDICATORS_POSITION = {
  top: 'top',
  bottom: 'bottom'
};